import { createComponent } from '@ycos/fela'

export const getFontStyles = (typography, { type, color = 'PrimaryGrey', name }) => {
  const style = typography.styles[type][name]
  const colorValue = typography.colors[color]

  if (!style) throw new Error(`${name}-${type} style not found`)
  if (!colorValue) throw new Error(`${colorValue} color not found`)

  const breakpointRuleMap = {
    bp2: 'screen-medium',
    bp3: 'screen-large',
    bp4: 'screen-xlarge'
  }

  const compoundStyle = Object.keys(style).reduce(
    (acc, breakpointStyle) => {
      const breakpointRule = breakpointRuleMap[breakpointStyle]
      if (style[breakpointStyle] && breakpointRule) {
        acc[breakpointRule] = {
          ...style[breakpointStyle]
        }
      }
      return acc
    },
    {
      ...style.bp1,
      color: colorValue
    }
  )

  return {
    ...compoundStyle,
    fontFamily: `${compoundStyle.fontFamily}, MSung PRC Medium`
  }
}

export const createFontStyle = (containerName, { type, tagName, color = 'PrimaryGrey', name }, additionalCssRules) => {
  const baseStyleComponent = createComponent(
    containerName,
    (...args) => {
      if (!args[0].theme.typography) {
        throw new Error('No theme typography')
      }

      let fontStyles = {}

      try {
        fontStyles = getFontStyles(args[0].theme.typography, {
          type,
          color,
          name
        })
      } catch (err) {
        console.error(err)
      }

      return {
        ...fontStyles,
        ...(additionalCssRules ? additionalCssRules(...args) : {})
      }
    },
    tagName
  )

  return baseStyleComponent
}
